import { Component, OnInit, SecurityContext, NO_ERRORS_SCHEMA } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { ActivatedRoute } from '@angular/router';
import { tick } from '@angular/core/testing';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { HeaderOneComponent } from '../shared/header/header-one/header-one.component';
@Component({
  standalone: true,
  selector: 'app-detail-blog-view',
  templateUrl: './detail-blog-view.component.html',
  styleUrl: './detail-blog-view.component.scss',
  imports: [CommonModule, HeaderOneComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class DetailBlogViewComponent {
  [key: string]: any;
  constructor() {}

  ngOnInit() {}

  getBlogBySlugName(obj:any) {}
}
